import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.hk'

export default createLendingBundle(whitepaper)
